// extracted by mini-css-extract-plugin
export default {"nftBuyOfferItem":"S1pCRBK43TGpTlycwniA","nftBuyOfferItemPrice":"Gv_lAytaeUu1c0rfJU5e","nftBuyOfferItemLogo":"CWv6lM3hPg8M9oOWawZJ"};